<template>
  <ul class="shopCon clear">
    <li
      class="shop"
      @click="$router.push({ name: 'product-detail', query: { id: item.id } })"
      v-for="(item, index) in shoplist"
      :key="index"
    >
      <div class="icon_img">
        <img :src="item.iconSrc" :alt="item.text" />
      </div>
      <div class="shop_img">
        <img :src="item.img" :alt="item.text" />
      </div>
      <div class="shop_txt">
        <span>{{ item.text }}</span>
        <div class="shop_txt_img"></div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["shoplist"],
};
</script>
<style lang="scss">
.shopCon {
}
.shop {
  width: 23.07vw;
  float: left;
  margin-right: 1.82vw;
  margin-bottom: 1.82vw;
  cursor: pointer;
  position: relative;
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  &:hover {
    .shop_img img {
      transform: scale(1.06, 1.06);
      transition: 0.6s;
    }
    .shop_txt {
      color: #fff;
      background: #83bb26;
      transition: 0.6s;
      .shop_txt_img {
        background: url("../../assets/images/recruit/jtbai.png") left center
          no-repeat;
        background-size: 100%;
      }
    }
  }
  .icon_img {
    width: 2.76vw;
    height: 1.67vw;
    position: absolute;
    top: 0.83vw;
    left: 0.63vw;
    z-index: 66;
    img {
      display: block;
      width: 100%;
    }
  }
  .shop_img {
    width: 23.07vw;
    width: 23.07vw;
    height: 14.53vw;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .shop_txt {
    width: 100%;
    height: 2.24vw;
    line-height: 2.24vw;
    text-align: center;
    font-size: 0.94vw;
    color: #83bb26;
    background-color: #ffffff;
    box-shadow: 0vw 0.21vw 0.36vw 0vw rgba(0, 0, 0, 0.13);
    .shop_txt_img {
      width: 1.82vw;
      height: 0.73vw;
      margin-left: 1.04vw;
      display: inline-block;
      background: url("../../assets/images/recruit/jtlu.png") left center
        no-repeat;
      background-size: 100%;
    }
  }
}
@media (min-width: 1920px) {
  .shopCon {
  }
  .shop {
    width: 443px;
    float: left;
    margin-right: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    &:hover .shop_img img {
      transform: scale(1.06, 1.06);
      transition: 0.6s;
    }
    &:hover .shop_txt {
      color: #fff;
      background: #83bb26;
      transition: 0.6s;
    }
    &:hover .shop_txt .shop_txt_img {
      background: url("../../assets/images/recruit/jtbai.png") left center
        no-repeat;
      background-size: 100%;
    }
    .icon_img {
      width: 53px;
      height: 32px;
      position: absolute;
      top: 16px;
      left: 12px;
      img {
        display: block;
        width: 100%;
      }
    }
    .shop_img {
      width: 443px;
      width: 443px;
      height: 279px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .shop_txt {
      width: 100%;
      height: 43px;
      line-height: 43px;
      text-align: center;
      font-size: 18px;
      color: #83bb26;
      background-color: #ffffff;
      box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.13);
      .shop_txt_img {
        width: 35px;
        height: 14px;
        margin-left: 20px;
        display: inline-block;
        background: url("../../assets/images/recruit/jtlu.png") left center
          no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>